import { render, staticRenderFns } from "./MockSection.vue?vue&type=template&id=14687a5b&scoped=true"
import script from "./MockSection.vue?vue&type=script&lang=js"
export * from "./MockSection.vue?vue&type=script&lang=js"
import style0 from "./MockSection.vue?vue&type=style&index=0&id=14687a5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14687a5b",
  null
  
)

export default component.exports